import React, { createContext, useState } from "react"

export const ContextWrapper = ({children}) => {
    
    const [showModal, setShowModal] = useState('')
    const [modalStep, setModalStep] = useState(1)
    const [disableBtn, setDisableBtn] = useState(false)
    const [action, setAction] = useState({name: '', value: null})
    const [urlDetails, setUrlDetails] = useState({SQN: '', LQN: '', uuid: '', lang: '', cType: ''})
    const [userInfo, setUserInfo] = useState({
        PhoneNumber: '',
        Name: '',
        LastName: '',
        MothersLastName: '',
        ClientNumber:''
    })

    return(
        <Context.Provider
            value={{
                showModal: showModal,
                setShowModal: setShowModal,
                modalStep: modalStep,
                setModalStep: setModalStep,
                userInfo: userInfo,
                setUserInfo: setUserInfo,
                action: action,
                setAction: setAction,
                disableBtn: disableBtn,
                setDisableBtn: setDisableBtn,
                urlDetails: urlDetails,
                setUrlDetails: setUrlDetails
            }}
        >
            {children}
        </Context.Provider>
    )
}

const Context = createContext()

export default Context